module.exports = __webpack_public_path__ + "static/media/16_l_kolona_0.99_21.2.ba3df4d5.png";